import { addLabelArray } from "helpers/addLabelArray";
import electronicEquipmentActionTypes from "./types";

const {
  ADD_ELECTRONIC_EQUIPMENT,
  DELETE_ELECTRONIC_EQUIPMENT,
  EDIT_ELECTRONIC_EQUIPMENT,
  GET_ELECTRONIC_EQUIPMENT_TYPES,
  GET_ELECTRONIC_EQUIPMENT_DATA,
  RESTORE_INITIAL_STATE,
  SET_ELECTRONIC_EQUIPMENT_SEARCH_FILTERS
} = electronicEquipmentActionTypes;  

const INITIAL_STATE = {
  equipment: [],
  equipmentTypes: [],
  isLoadingComp: {},
  station: null,
  status: 'ACTIVE',
  hasSearched: false
};

export const electronicEquipmentReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ADD_ELECTRONIC_EQUIPMENT: {
      const belongsToCurrentStation = state.station && payload.idStation === state.station.id;
      return {
        ...state,
        equipment: belongsToCurrentStation ? [...state.equipment, payload] : state.equipment
      };
    }

    case DELETE_ELECTRONIC_EQUIPMENT: {
      const filtered = state.equipment.filter(eq => eq.id !== payload);
      return {
        ...state,
        equipment: filtered
      };
    }

    case EDIT_ELECTRONIC_EQUIPMENT: {
      const edited = state.equipment.map(eq => eq.id === payload.id ? payload : eq);
      return {
        ...state,
        equipment: edited
      };
    }

    case GET_ELECTRONIC_EQUIPMENT_DATA:
      return {
        ...state,
        equipment: payload,
        hasSearched: true,
      };

    case GET_ELECTRONIC_EQUIPMENT_TYPES: {
      const formattedTypes = addLabelArray(payload, 'name');
      return {
        ...state,
        equipmentTypes: formattedTypes,
      };
    }
    
    case RESTORE_INITIAL_STATE:
      return INITIAL_STATE;

    case SET_ELECTRONIC_EQUIPMENT_SEARCH_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
        ...(payload.key === 'station' && { hasSearched: false, equipment: [] }),
      };

    default:
      return state;
  }
};